import { React, useEffect, useRef, useState } from "react";
import ModalBox from "./ModalBox";
import { Input, Button } from "antd";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import { calcInputSize } from "../utilities";

function QualificationModalBox(props) {
  const {
    selectedOtherQualification,
    setSelectedOtherQualification,
    tempOtherQualification,
    setTempOtherQualification,
    qualificationMatchPreset,
    addOtherQualificationsToList,
    addTheQualificationMatchToList,
  } = props;
  // const [inputRef, setInputRef] = useState(null);

  const inputRef = useRef(null);

  // useEffect(() => {
  //   if (inputRef && inputRef.current) {
  //     inputRef.inputRef.focus();
  //   }
  // }, [inputRef, selectedOtherQualification]);

  return (
    <ModalBox
      title="Enter Qualification"
      visible={selectedOtherQualification}
      setVisible={() => setSelectedOtherQualification()}
      className="changeModal"
    >
      <div>
        <div>Please enter the qualification you could not find in the list</div>
        <div className="changeModal_inputMargin" style={{ margin: "15px 0" }}>
          <Input
            value={tempOtherQualification}
            onChange={(e) => setTempOtherQualification(e.target.value)}
            size={calcInputSize}
            placeholder="Other Qualification"
            allowClear
            ref={inputRef}
            autoComplete="off"
            prefix={<SafetyCertificateOutlined />}
          />
          {qualificationMatchPreset ? (
            <span className="text_danger">
              Qualification exists{" "}
              <Button
                className="link_button"
                size={"small"}
                type="link"
                onClick={() =>
                  addTheQualificationMatchToList(qualificationMatchPreset)
                }
              >
                {qualificationMatchPreset}
              </Button>
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="changeModal_buttons">
          <Button
            onClick={() => setSelectedOtherQualification(false)}
            className="button_default"
            style={{ marginRight: 15 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => addOtherQualificationsToList()}
            disabled={
              tempOtherQualification.length <= 1 || qualificationMatchPreset
            }
            type="primary"
          >
            Submit
          </Button>
        </div>
      </div>
    </ModalBox>
  );
}

export default QualificationModalBox;
